var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useFrame } from "@react-three/fiber";
import { useEffect, useRef, useState } from "react";
/**
 * Read keyboard layout (default is WASD)
 */
export var useKeyboardLayout = function () {
    var _a = __read(useState(function () { return ({
        up: "w",
        left: "a",
        down: "s",
        right: "d",
    }); }), 2), layout = _a[0], setLayout = _a[1];
    var getLayout = function () { return __awaiter(void 0, void 0, void 0, function () {
        var keyboard, layout_1, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    keyboard = navigator.keyboard;
                    if (!(keyboard && keyboard.getLayoutMap)) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, keyboard.getLayoutMap()];
                case 2:
                    layout_1 = _a.sent();
                    if (layout_1 && layout_1.size > 0) {
                        setLayout({
                            up: layout_1.get("KeyW") || "w",
                            left: layout_1.get("KeyA") || "a",
                            down: layout_1.get("KeyS") || "s",
                            right: layout_1.get("KeyD") || "d",
                        });
                    }
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        getLayout();
    }, []);
    return layout;
};
/**
 * React on key input to call a moving function with a fast frequency
 */
export var useArrowsControls = function (onMove) {
    var layout = useKeyboardLayout();
    var keyPressed = useRef([]);
    // Update movement on every frame
    useFrame(function () {
        if (keyPressed.current.length > 0) {
            keyPressed.current.forEach(function (direction) {
                onMove(direction);
            });
        }
    });
    // Setup keyboard events
    useEffect(function () {
        function onKeyDown(e) {
            // Read key
            var mapping = Object.entries(layout);
            var input = mapping.find(function (_a) {
                var _b = __read(_a, 2), key = _b[1];
                return key === e.key;
            });
            if (input && !keyPressed.current.includes(input[0])) {
                // Add it to pressed keys
                keyPressed.current.push(input[0]);
            }
        }
        function onKeyUp(e) {
            // Read key
            var mapping = Object.entries(layout);
            var input = mapping.find(function (_a) {
                var _b = __read(_a, 2), key = _b[1];
                return key === e.key;
            });
            if (input && keyPressed.current.includes(input[0])) {
                // Remove it from pressed keys
                keyPressed.current = keyPressed.current.filter(function (direction) { return direction !== input[0]; });
            }
        }
        document.addEventListener("keydown", onKeyDown, true);
        document.addEventListener("keyup", onKeyUp, true);
        return function () {
            document.removeEventListener("keydown", onKeyDown);
            document.removeEventListener("keyup", onKeyUp);
        };
    }, [layout]);
};
